<template>
  <main role="main">
    <div class="container-xxl py-4">
      <div class="d-flex flex-row align-items-center justify-content-between mb-4">
        <h4 class="m-0">{{ $t("contactList") }}</h4>
        <div>
          <!-- <b-button class="mr-4" variant="outline-secondary" @click="onClickReloadBtn">
            <b-icon icon="arrow-clockwise"></b-icon> {{ $t("reload") }}
          </b-button> -->
          <b-button class="mr-4" variant="outline-success" :disabled="!totalItems" @click="debouncedOnClickDownload()">
            <b-icon-download class="mr-2"></b-icon-download> {{ $t("export") }}
          </b-button>

          <b-button class="mr-4" variant="outline-secondary" v-b-modal:new-import-excel>
            <b-icon icon="upload" class="mr-2"></b-icon> {{ $t("importFromFile") }}
          </b-button>
          <b-button class="mr-4" variant="outline-primary" v-b-modal:new-contact-modal>
            <b-icon icon="plus"></b-icon> {{ $t("createNew") }}
          </b-button>
          <b-button variant="outline-danger" @click="onClickDeleteAll">
            <b-icon icon="trash"></b-icon> {{ $t("deleteAll") }}
          </b-button>
        </div>
      </div>

      <div class="d-flex flex-row align-items-center justify-content-between mb-3">
        <div>
          <b-form class="d-inline-block" inline @submit.prevent="onSubmitSearch">
            <b-form-input class="mr-2" type="search" minlength="2" maxlength="200" v-model="searchText"
              :placeholder="$t('adminSearchPlaceholder')" style="min-width: 300px;" />
            <b-button type="submit" variant="primary">{{ $t("search") }}</b-button>
          </b-form>
        </div>
        <div class="d-flex flex-row align-items-center">

        </div>
      </div>

      <b-table ref="table" :fields="tableFields" :items="tableItemProvider" hover primary-key="id" show-empty
        :per-page="itemsPerPage" :current-page="currentPage">
        <template v-slot:table-busy>
          <div class="text-center text-secondary py-4">{{ $t("loadingData") }}</div>
        </template>
        <template v-slot:empty>
          <div class="text-center text-secondary py-4">{{ $t("noData") }}</div>
        </template>
        <template v-slot:cell(imgUploadStatus)="data">
          <b-badge :variant="statusBadgeVariant[data.item.imgUploadStatus]">{{ data.item.imgUploadStatus }}</b-badge>
        </template>
        <template v-slot:cell(actions)="data">
          <b-button variant="outline-primary" size="sm" class="mr-3" @click="onClickEditContact(data.item)">{{
            $t("update") }}</b-button>
          <b-button variant="outline-danger" size="sm" @click="onClickDeleteContact(data.item)">{{ $t("actionDelete")
          }}</b-button>
        </template>
      </b-table>

      <div class="d-flex flex-row align-items-center justify-content-between">
        <div></div>
        <div class="d-flex flex-row align-items-center">
          <div v-if="totalItems" class="text-right flex-shrink-0 mr-3">{{ $t("resultCount", { count: totalItems }) }}
          </div>
          <b-pagination class="my-0 mr-3" v-model="currentPage" :total-rows="totalItems"
            :per-page="itemsPerPage"></b-pagination>
          <b-form-select v-model="itemsPerPage" :options="itemsPerPageSelections"></b-form-select>
        </div>
      </div>
    </div>

    <b-modal id="import-contacts-from-excel-file-modal" :title="$t('importContactFromFile')" hide-footer
      no-close-on-backdrop dialog-class="custom-modal-width">
      <ImportContactsFromExcelFileModal modal-id="import-contacts-from-excel-file-modal" :activeFID="user.activeFaceId"
        @submitted="refreshData" />
    </b-modal>

    <b-modal id="new-contact-modal" :title="$t('addNewContact')" hide-footer no-close-on-backdrop>
      <NewContactModal modal-id="new-contact-modal" :contacts="contacts" :activeFID="user.activeFaceId"
        @submitted="refreshData" />
    </b-modal>

    <b-modal id="edit-contact-modal" :title="$t('updateContact')" hide-footer no-close-on-backdrop>
      <EditContactModal modal-id="edit-contact-modal" :contacts="contacts" :activeFID="user.activeFaceId"
        :contact="contactToEdit" @submitted="refreshData" />
    </b-modal>

    <!--Modal import excel new-->
    <!--Modal Import dữ liệu  @submitted="refreshData" -->
    <b-modal id="new-import-excel" :title="$t('importParticipants')" hide-footer no-close-on-backdrop size="md">
      <ImportExcelModal modal-id="new-import-excel" :activeFID="user.activeFaceId" :typeModal="'contact'"
        @imported="handleImportedContacts"></ImportExcelModal>
    </b-modal>

    <!--Preview Modal-->
    <b-modal id="preview-import-modal" :title="$t('previewData')" hide-footer no-close-on-backdrop size="xl">
      <PreviewFileExcel modal-id="preview-import-modal"  :activeFID="user.activeFaceId" :initial-data="importData"
        :type-modal="'contact'" @imported="handleFinalSave" />
    </b-modal>
  </main>


</template>

<style lang="scss" scoped>
#new-import-excel .modal-dialog
{
  max-width: 80vw!important;
}

</style>

<script lang="ts">
import { Component, Vue, Ref } from 'vue-property-decorator';
import _ from "lodash";
import BaseComponent from "@/components/BaseComponent";
import * as contactService from "@/service/contactService";
import * as userService from "@/service/userService";

import { BTable, BvTableCtxObject, BvTableProviderPromiseResult } from "bootstrap-vue/src/components/table";
import NewContactModal from "@/components/contact/NewContactModal.vue";
import EditContactModal from "@/components/contact/EditContactModal.vue";
import { BvTableFieldArray } from "bootstrap-vue";
import ImportContactsFromExcelFileModal from "@/components/contact/ImportContactsFromExcelFileModal.vue";
import { BounceTimes } from '../enums/TimesNumbers';
import * as exportService from "@/service/exportService";
import ImportExcelModal from '@/components/modals/ImportExcelModal.vue';
import PreviewFileExcel from '@/components/modals/PreviewFileExcel.vue';
import { jsonToExcelFile } from '@/service/util';
import { SearchRequestManager } from "@/utils/search-request-manager";




@Component({
  components: { ImportContactsFromExcelFileModal, NewContactModal, EditContactModal, ImportExcelModal, PreviewFileExcel}
})
export default class ContactList extends BaseComponent {

  // 
  importData: any[] = [];

  //
  user = userService.getCurrentUser() || null;

  tableFields: BvTableFieldArray = [
    {
      key: "name",
      label: this.$t("fullName").toString(),
      thClass: "text-nowrap",
      tdClass: "text-break",
    },
    {
      key: "email",
      label: "Email",
      thClass: "text-nowrap",
    },
    {
      key: "phone",
      label: this.$t("phoneNumber").toString(),
      thClass: "text-nowrap",
    },
    {
      key: "title",
      label: this.$t("workTitle").toString(),
      thClass: "text-nowrap",
    },
    {
      key: "department",
      label: this.$t("workDepartment").toString(),
      thClass: "text-nowrap",
    },
    {
      key: "organization",
      label: this.$t("workOrganization").toString(),
      thClass: "text-nowrap",
    },

  ];

  @Ref("table") table: BTable;
  readonly statusBadgeVariant = {
    FAILURE: "warning",
    SUCCESS: "success",
    NOT_AVAILABLE: "danger"
  };

  searchText = "";

  contacts = [];
  currentPage = 1;
  totalItems = 0;
  searchManager = new SearchRequestManager();
  itemsPerPage = 20;
  itemsPerPageSelections = [
    { value: 20, text: "20 " + this.$t("itemsPerPage").toString() },
    { value: 50, text: "50 " + this.$t("itemsPerPage").toString() },
    { value: 100, text: "100 " + this.$t("itemsPerPage").toString() },
    { value: 200, text: "200 " + this.$t("itemsPerPage").toString() },
  ];

  contactToEdit = null;

  async mounted() {
    let extraCol = [];

    if (this.user.activeFaceId) {
      extraCol = [{
        key: "code",
        label: "Code",
        thClass: "text-nowrap",
      },
      {
        key: "imgUploadStatus",
        label: "Trạng thái",
        thClass: "text-nowrap",
      },
      {
        key: "actions",
        label: "",
        thClass: "text-nowrap",
        tdClass: "text-nowrap"
      }
      ];
    }
    else {
      extraCol = [
        {
          key: "actions",
          label: "",
          thClass: "text-nowrap",
          tdClass: "text-nowrap"
        }];
    }
    this.tableFields = this.tableFields.concat(extraCol);
    this.user = await userService.getUserDetail();
  }

  onClickReloadBtn() {
    this.searchText = "";
    this.currentPage = 1;
    this.table.refresh();
  }

  //
  debouncedOnClickDownload = _.debounce(() => {
    this.onClickDownload();
  }, BounceTimes.BOUNCETIMES);
  async onClickDownload() {
    try {
      let customers = [];
      customers = await contactService.getAllContactsForExport();
      await exportService.exportContactList(customers);
    } catch (e) {
      console.error(e);
      this.toastError(e);
    }
  }


  //
  debounceonClickSearch = _.debounce(() => {
    this.onClickSearch();
  }, BounceTimes.BOUNCETIMES);

  onSubmitSearch() {
    this.searchManager.onSubmit({
      debounceFn: this.debounceonClickSearch,
      resetPage: () => { this.currentPage = 1; },
      execute: () => { this.table.refresh(); }
    });
  }

  onClickSearch() {
    this.currentPage = 1;
    this.table.refresh();
  }

  refreshData() {
    this.table.refresh();
  }

  async onClickDeleteAll() {
    const modalMessage = this.$t("deleteAllContactsConfirm").toString();
    const confirmDelete = await this.$bvModal.msgBoxConfirm(modalMessage, {
      okVariant: 'danger',
      okTitle: this.$t("yes").toString(),
      cancelTitle: this.$t("no").toString(),
    });

    if (confirmDelete) {
      try {
        await contactService.deleteAllContacts();
        this.table.refresh();
      } catch (e) {
        this.toastError(e);

      }
    }
  }


  async tableItemProvider(ctx: BvTableCtxObject): Promise<BvTableProviderPromiseResult> {
    const currentRequestId = this.searchManager.nextId();
    try {
      const res = await contactService.getAllContacts(ctx.currentPage, ctx.perPage, this.searchText?.trim());
      if (!this.searchManager.isLatest(currentRequestId)) {
        return this.contacts || [];
      }
      this.contacts = res.data;
      this.totalItems = res.total;
      return res.data;

    } catch (e) {
      if (this.searchManager.isLatest(currentRequestId)) {
        this.toastError(e);
      }
      return [];
    }
  }

  onClickEditContact(contact) {
    this.contactToEdit = contact;
    this.$bvModal.show("edit-contact-modal");
  }

  async onClickDeleteContact(contact) {
    const modalMessage = this.$t("deleteRecordConfirmation2", { name: contact.name, id: contact.id }).toString();
    const confirmDelete = await this.$bvModal.msgBoxConfirm(modalMessage, {
      okVariant: 'danger',
      okTitle: this.$t("yes").toString(),
      cancelTitle: this.$t("no").toString(),
      messageHtml: true,
      contentClass: 'text-break custom-confirm-body',
      modalClass: 'custom-confirm-modal',
    });

    if (confirmDelete) {
      try {
        await contactService.deleteContact(contact.id);
        this.refreshData();
        this.toastSuccessDelay(this.$t("deleteContactSuccessful").toString());

      } catch (e) {
        this.toastError(e);
      }
    }
  } 

  // Hàm xử lý khi đóng modal Import
  handleImportedContacts(data: any[]) {
    if (!data || data.length === 0) return;

    // 1. Lưu dữ liệu import
    this.importData = data;


    // 2. Đóng modal import
    this.$bvModal.hide("new-import-excel");

    // 3. Mở modal preview (đợi DOM ổn định)
    this.$nextTick(() => {
      this.$bvModal.show("preview-import-modal");
    });
  }

  // Hàm xử lý khi bấm nút xác nhận modal preview
  async handleFinalSave(finalData: any[]) {
    if (!finalData || !finalData.length) return;

    try {
      const file = jsonToExcelFile(finalData, "contacts-import.xlsx");

      await contactService.uploadContactsExcelFile(file);

      this.$bvModal.hide("preview-import-modal");
      this.importData = [];
      this.refreshData();

      this.toastSuccessDelay(this.$t("importContactsFromFileSuccessful").toString());
    } catch (e) {
      this.toastError(this.$t("importFail").toString());
    }
  }

}
</script>
